export const TRU_NARRATIVE = 'trunarrative';

export const TRU_NARRATIVE_HAVE_COPY_ID_FAX_KEY = 145;

export const TRU_NARRATIVE_HAVE_COPY_ID_FAX_VALUE = {
    VERIFIED: '1'
    // NOT_VERIFIED: '0'
};

export const TRU_NARRATIVE_VERIFICATION_STATUS = {
    VERIFIED: 'verified',
    // PENDING: 'pending',
    DISABLED: 'disabled'
};

export const TRU_NARRATIVE_VERIFIED_STATUS = {
    value: TRU_NARRATIVE_VERIFICATION_STATUS.VERIFIED,
    showVerifyButton: false
};

export const OPEN_IN = {
    IFRAME: 'iframe',
    NEW_TAB: 'newTab',
    NEW_WINDOW: 'newWindow'
};
